export default "__VITE_ASSET__BLMX0124__"